<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ser">
<p class="sert"><a class="page" id="pii"></a>THE KENNETH NEBENZAHL, JR., LECTURES IN THE HISTORY OF CARTOGRAPHY</p>
<p class="sers">PUBLISHED IN ASSOCIATION WITH THE HERMON DUNLAP SMITH CENTER FOR THE HISTORY OF CARTOGRAPHY, THE NEWBERRY LIBRARY</p>
<p class="serau">Series Editor, James R. Akerman</p>
<p class="serah">ALSO IN THE SERIES</p>
<p class="seraft"><i>Maps: A Historical Survey of Their Study and Collecting</i></p>
<p class="serau">by R. A. Skelton</p>
<p class="ser"><i>Five Centuries of Map Printing</i></p>
<p class="serau">by David Woodward</p>
<p class="ser"><i>British Maps of Colonial America</i></p>
<p class="serau">by William Patterson Cumming</p>
<p class="ser"><i>Mapping the American Revolutionary War</i></p>
<p class="serau">by J. B. Harley, Barbara Bartz Petchenik, and Lawrence W. Towner</p>
<p class="ser"><i>Art and Cartography: Six Historical Essays</i></p>
<p class="serau">edited by David Woodward</p>
<p class="ser"><i>Monarchs, Ministers, and Maps: The Emergence of Cartography as a Tool of Government in Early Modern Europe</i></p>
<p class="serau">edited by David Buisseret</p>
<p class="ser"><i>Rural Images: Estate Maps in the Old and New Worlds</i></p>
<p class="serau">edited by David Buisseret</p>
<p class="ser"><i>Envisioning the City: Six Studies in Urban Cartography</i></p>
<p class="serau">edited by David Buisseret</p>
<p class="ser"><i>Cartographic Encounters: Perspectives on Native American Mapmaking and Map Use</i></p>
<p class="serau">edited by G. Malcolm Lewis</p>
<p class="ser"><i>The Commerce of Cartography: Making and Marketing Maps in Eighteenth-Century France and England</i></p>
<p class="serau">by Mary Sponberg Pedley</p>
<p class="ser"><i>Cartographies of Travel and Navigation</i></p>
<p class="serau">edited by James R. Akerman</p>
<p class="ser"><i>The Imperial Map: Cartography and the Mastery of Empire</i></p>
<p class="serau">edited by James R. Akerman</p>
<p class="ser"><i>Ancient Perspectives: Maps and Their Place in Mesopotamia, Egypt, Greece, and Rome</i></p>
<p class="serau">edited by Richard J. A. Talbert</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Akerman-0003.vue?0df7c710